import { render, staticRenderFns } from "./EngagementRewardVersionSelector.vue?vue&type=template&id=bfd295bc&scoped=true"
import script from "./EngagementRewardVersionSelector.vue?vue&type=script&lang=ts"
export * from "./EngagementRewardVersionSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd295bc",
  null
  
)

export default component.exports